import React, { Component } from "react";
import { PageHeader } from "antd";
import DownloadCSV from "../components/DownloadCSV/DownloadCSV";

class DownloadFileCSV extends Component {
  render() {
    return (
      <div>
        <PageHeader
          title="Orders Export Files"
          onBack={() => this.props.history.goBack()}
        />
        <DownloadCSV />
      </div>
    );
  }
}

export default DownloadFileCSV;
